<template>
  <div class="tabs-wrap tabs-position">
    <van-tabs @change="clearQuery" @disabled="noData" sticky>
      <van-tab>
        <div slot="title">
          {{ tabNames[0].name }}
          {{ tabNames[0].count > 0 ? "(" + tabNames[0].count + ")" : "" }}
        </div>
        <!-- <tab-detail :positionDetail="data"
                            :positionSurveyView="data ? data.positionSurveyView : {}"></tab-detail> -->

        <tab-survey
          :position-detail="data"
          :position-survey-view="data ? data.positionSurveyView : {}"
          :position-survey="data ? data.positionSurvey : {}"
        ></tab-survey>
      </van-tab>
      <van-tab :disabled="consult && consult.questions ? false : true">
        <div slot="title">
          {{ tabNames[1].name }}
          {{ tabNames[1].count > 0 ? "(" + tabNames[1].count + ")" : "" }}
        </div>
        <tab-qa :consult="consult"></tab-qa>
      </van-tab>
      <van-tab :disabled="expensePolicy ? false : true">
        <div slot="title">
          {{ tabNames[2].name }}
          {{ tabNames[2].count > 0 ? "(" + tabNames[2].count + ")" : "" }}
        </div>
        <tab-rec :expensePolicy="expensePolicy"></tab-rec>
      </van-tab>
      <van-tab
        :disabled="
          positionStatistics && positionStatistics.homoPosition > 0
            ? false
            : true
        "
      >
        <div slot="title">
          {{ tabNames[3].name
          }}<span
            v-if="positionStatistics && positionStatistics.homoPosition > 0"
            style="display: inline-block;"
            >({{ positionStatistics.homoPosition }})</span
          >
        </div>
        <tab-nearby :type="1"></tab-nearby>
      </van-tab>
      <van-tab
        :disabled="
          positionStatistics && positionStatistics.aiTalentsTotal > 0
            ? false
            : true
        "
      >
        <div slot="title">
          {{ tabNames[4].name
          }}<span
            v-if="positionStatistics && positionStatistics.aiTalentsTotal > 0"
            style="display: inline-block;"
            >({{ positionStatistics.aiTalentsTotal }})</span
          >
        </div>
        <tab-ai :type="1"></tab-ai>
      </van-tab>
      <van-tab :disabled="positionFeedback ? false : true">
        <div slot="title">
          {{ tabNames[5].name }}
          {{ tabNames[5].count > 0 ? "(" + tabNames[5].count + ")" : "" }}
        </div>
        <div class="tab-content">
          <p class="list-info" v-for="time in positionFeedback">
            <span>{{ time.createTime | date }}</span
            ><span>{{ time.comment }}</span>
          </p>
        </div>
      </van-tab>
      <van-tab :disabled="positionDyn ? false : true">
        <div slot="title">
          {{ tabNames[6].name }}
          {{ tabNames[6].count > 0 ? "(" + tabNames[6].count + ")" : "" }}
        </div>
        <div class="tab-content">
          <p class="list-info" v-for="time in positionDyn">
            <span>{{ time.createTime | date }}</span
            ><span>{{ time.comment }}</span>
          </p>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import TabDetail from "./tabDetail";
import TabSurvey from "./tabSurvey";
import TabQa from "./tabQa";
import TabRec from "./tabRec";
import TabNearby from "./tabNearby";
import TabAi from "./tabAi";
import {
  getAiTalents,
  getListHomo,
  getPositionDynamic,
  getPositionFeedback,
  getPositionQuestions,
  getRecommendNotice,
} from "@/api/positions";

export default {
  components: { TabAi, TabNearby, TabRec, TabQa, TabDetail, TabSurvey },
  props: {
    data: {},
    positionStatistics: null,
    id: {
      type: Number,
      default: 94544,
    },
    eId: {
      type: Number,
      default: 94544,
    },
  },
  data() {
    return {
      query: this.$route.query,
      tabNames: [
        {
          name: "职位调研",
          count: 0,
        },
        {
          name: "职位问答",
          count: 0,
        },
        {
          name: "推荐须知",
          count: 0,
        },
        {
          name: "相似职位",
          count: 0,
        },
        {
          name: "AI人岗匹配",
          count: 0,
        },
        {
          name: "职位反馈",
          count: 0,
        },
        {
          name: "职位动态",
          count: 0,
        },
      ],
      // activeName:'tab1',
      consult: {},
      positionFeedback: null,
      positionDyn: null,
      expensePolicy: null,
      enterpriseList: null,
      homoList: null,
      aiTalents: null,
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 10,
    };
  },
  methods: {
    init() {
      this.loadQuestions(); //职位问答
      this.loadNotice(); //推荐须知
      this.loadFeedback(); //职位反馈
      this.loadDynamic(); //职位动态
      // this.loadListHomo();//相似职位
      // this.loadAiTalents();//AI人岗匹配
    },
    //清空路由
    clearQuery() {
      delete this.$route.query.enterpriseId;
    },
    //暂无数据
    noData() {
      this.$toast({
        type: "fail",
        message: "当前标签页暂无数据",
      });
    },
    //职位问答
    loadQuestions() {
      let params = { pageNo: this.pageNo, pageSize: 100, ...this.$route.query };
      params.positionId = this.id;
      getPositionQuestions(params).then((res) => {
        if (res && res.data) {
          this.tabNames[1].count = res.data.total || 0;
          this.consult = res.data || {};
        }
      });
    },
    //推荐须知
    loadNotice() {
      getRecommendNotice(this.eId, this.query).then((res) => {
        if (res && res.data) {
          this.expensePolicy = res.data || null;
        }
      });
    },
    //职位反馈
    loadFeedback() {
      this.query.id = this.id;
      getPositionFeedback(this.query).then((res) => {
        if (res && res.data) {
          this.positionFeedback = res.data.list || null;
          this.tabNames[5].count = res.data.total || 0;
        }
      });
    },
    //职位动态
    loadDynamic() {
      this.query.id = this.id;
      getPositionDynamic(this.query).then((res) => {
        if (res && res.data) {
          this.positionDyn = res.data.list || null;
          this.tabNames[6].count = res.data.total || 0;
        }
      });
    },
    //相似职位
    loadListHomo(item) {
      let homoQuery = {
        pageSize: 1000,
        pageNo: 1,
        scene: 5,
        sourceId: this.id,
      };
      getListHomo(homoQuery).then((res) => {
        if (res && res.data) {
          this.enterpriseList = res.data.enterpriseList || null;
          this.homoList = res.data.positionList || null;
          this.tabNames[3].count = res.data.total || 0;
        }
      });
    },
    //AI人岗匹配
    loadAiTalents(item) {
      let aiQuery = {
        queryType: 1,
        pageSize: 1000,
        pageNo: 1,
        positionId: this.id,
      };
      getAiTalents(this.id, aiQuery).then((res) => {
        if (res && res.data) {
          this.aiTalents = res.data.talentList || null;
          this.tabNames[4].count = res.data.total || 0;
        }
      });
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" rel="stylesheet/scss">
.tabs-wrap {
  .van-tab {
    font-size: 14px;
  }

  .tab-content {
    padding: 10px 15px;
    position: relative;
  }
}
</style>
<style scoped lang="scss" rel="stylesheet/scss">
.tabs-wrap {
  background-color: #fff;

  .tab-content {
    padding: 10px 15px;
    position: relative;
    min-height: 200px;

    .list-info {
      &:not(:last-child) {
        border-bottom: 0.5px dashed #e5e5e5;
        line-height: 44px;
        /*margin-bottom: 5px;*/
        /*padding-bottom: 5px;*/
      }

      span:first-child {
        margin-right: 10px;
        color: #666;
      }
    }
  }
}
</style>
